import { Suspense } from 'react';
import { getUIConfigForm } from '../uiRegistry';
import styles from '../ProjectEditForm.module.css';

function AnnotationUIPanel({
    annotationUI,
    setAnnotationUI,
    availableUIs,
    uisError,
    settingsLocked = false,
    projectItems = [],
    folderId,
    onReloadProjectItems,
}) {
    const selectedUIId = annotationUI?.id || '';

    const ConfigForm = selectedUIId ? getUIConfigForm(selectedUIId) : null;

    function handleUISelect(e) {
        const nextId = e.target.value;
        setAnnotationUI((prev) => {
            if (!nextId) {
                return { id: '', config: {} };
            }
            const preservedRoi = prev.config?.roi;
            return {
                id: nextId,
                config: preservedRoi ? { roi: preservedRoi } : {},
            };
        });
    }

    function handleConfigChange(config) {
        setAnnotationUI((prev) => ({ ...prev, config }));
    }

    return (
        <div className={styles.panel}>
            <h4 className={styles.panelTitle}>Annotation UI</h4>
            {settingsLocked && (
                <p className={styles.panelLockBanner}>
                    Published: return to draft to edit this section.
                </p>
            )}
            {uisError && <p className={styles.itemActionError}>{uisError}</p>}
            <div className={settingsLocked ? styles.panelDisabled : undefined}>
                <div className={styles.uiSelectRow}>
                    <label className={styles.uiSelectLabel} htmlFor="annotation-ui-select">
                        UI
                    </label>
                    <select
                        id="annotation-ui-select"
                        className={styles.uiSelect}
                        value={selectedUIId}
                        onChange={handleUISelect}
                        disabled={settingsLocked}
                    >
                        <option value="">— Select a UI —</option>
                        {availableUIs.map((ui) => (
                            <option key={ui.id} value={ui.id}>{ui.label}</option>
                        ))}
                    </select>
                </div>

                {ConfigForm && (
                    <div className={styles.configFormWrapper}>
                        <Suspense fallback={<span>Loading config form…</span>}>
                            <ConfigForm
                                value={annotationUI?.config}
                                onChange={handleConfigChange}
                                projectItems={projectItems}
                                folderId={folderId}
                                onReloadProjectItems={onReloadProjectItems}
                            />
                        </Suspense>
                    </div>
                )}

                {!selectedUIId && (
                    <p className={styles.emptyState}>Select an annotation UI above to configure it.</p>
                )}
            </div>
        </div>
    );
}

export default AnnotationUIPanel;
